import React from 'react'
import { ShortcutKeys, ShortcutTooltipTitle } from './ShortcutTooltipTitle'

export const fullScreenModeTooltipTitle = (
    <ShortcutTooltipTitle label="FullScreen Mode">
        <ShortcutKeys keys={['⇧', 'F']} />
    </ShortcutTooltipTitle>
)
